import { render, staticRenderFns } from "./BulkEditModal.vue?vue&type=template&id=33495390&"
import script from "./BulkEditModal.vue?vue&type=script&lang=js&"
export * from "./BulkEditModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkEditModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports